import React from 'react';

const InlineError = ({ text }) => <span style={{ color: 'red' }}>{text}</span>;

export default InlineError;
